import { CategoryFirstLevel } from './category-first-level';
import { ItiBaseDto } from '@/iti-core-vue';
import { CategoryThirdLevel } from './category-third-level';
import { Guid } from 'guid-typescript';

export class CategorySecondLevel extends ItiBaseDto {
    public code !: string;
    public description !: string;
    public categoryFirstLevel !: CategoryFirstLevel;
    public categoriesThirdLevel !: CategoryThirdLevel[];
    public externalID!: Guid;
}